import {
  actionButtonTheme,
  autoPlayCheckbox,
  autoPlayInterval,
  contentPages as cK,
  contentPagesToShow,
  editable,
  leaveGap,
  moduleTypeSelect,
  moduleWidthSelect,
  scrollOut,
} from '@/src/tools/contentModulesFieldName';
import { replaceI18nVariables } from '@/src/tools/tools';
import {
  EPreviewSize,
  SalesChannelModeWithSister,
} from '@/src/types/common/SalesChannel';
import {
  EModuleWidth,
  EResponsiveProductToShow,
  EnumModuleType,
} from '@/src/types/common/module';
import { get, uniqBy } from 'lodash';
import { checkResponsiveContentCarousel } from 'src/constrains/SalesChannelContent-Revamp/ModuleList/validator';
import i18n from '../i18n';
import {
  ModalField,
  ResponsiveContainer,
  ResponsiveField,
  countsOfItems,
  countsOfItems_i18n,
} from '../util';
import {
  ANIMATION,
  CAROUSEL,
  CONTENTS,
  MOUDLE_STYLE,
  TEXT,
  animationFields,
  contentTextFields,
  moduleStyleFields,
} from './constant';
import { carouselTypeOptionsGenerator } from './tools';

export default (
  values: any,
  responsiveType: EPreviewSize,
  salesChannelMode: SalesChannelModeWithSister,
) => {
  const carouselSetting = getSettingTemplate(
    values,
    responsiveType,
    salesChannelMode,
  );
  const moduleStyleSetting = getModuleStyleTemplate(
    values,
    responsiveType,
    EnumModuleType.ResponsiveContentCarousel,
  );
  const animation = getAnimationTemplate(values, responsiveType);
  const contents = getContentPageTemplate(values, responsiveType);
  return [
    {
      title: i18n['general.content.carousel'],
      id: CAROUSEL,
      field: carouselSetting,
      fields: [
        [moduleWidthSelect],
        [autoPlayCheckbox],
        [autoPlayInterval],
        [leaveGap],
        [scrollOut],
        [actionButtonTheme],
        [contentPagesToShow],
      ],
    },
    {
      title: i18n['general.content.moduleStyle'],
      id: MOUDLE_STYLE,
      type: ResponsiveContainer.ModuleStyle,
      field: moduleStyleSetting,
      fields: moduleStyleFields,
    },
    {
      title: i18n['general.content.animation'],
      id: ANIMATION,
      field: animation,
      fields: animationFields,
    },
    {
      title: i18n['general.content.text'],
      id: TEXT,
      field: [
        {
          field: ResponsiveField.ContentText,
          disabled: !(
            responsiveType === EPreviewSize.WIDE ||
            values[`${TEXT}_${editable}`]
          ),
        },
      ],
      fields: contentTextFields,
    },
    {
      title: i18n['general.content.contents'],
      id: CONTENTS,
      field: contents,
      fields: [[cK]],
      headerErrorDependencies: [[cK], [contentPagesToShow]],
      validator: (value, extra) => {
        const { checkContentPagesError } = checkResponsiveContentCarousel();
        const res = checkContentPagesError(value, extra);

        return res;
      },
    },
  ];
};

export const not_editable = [
  moduleTypeSelect,
  moduleWidthSelect,
  autoPlayCheckbox,
  autoPlayInterval,
  ...animation_not_editable,
];

export const getSettingTemplate = (
  values: any,
  responsiveType: EPreviewSize,
  salesChannelMode: SalesChannelModeWithSister,
) => {
  const contentOptions = cotentToShowOptions(responsiveType);
  const v =
    responsiveType === EPreviewSize.WIDE || values[`${CAROUSEL}_${editable}`];
  let commonFields: Array<any> = [
    {
      field: ResponsiveField.CarouselType,
      disabled: responsiveType !== EPreviewSize.WIDE || !v,
      options: carouselTypeOptionsGenerator({ salesChannelMode }),
    },
    {
      field: ResponsiveField.ModuleWidth,
      disabled: responsiveType !== EPreviewSize.WIDE || !v,
      options: [
        // { label: i18n['general.content.fullWidth'], value: EModuleWidth.FULL },
        { label: i18n['general.content.none'], value: EModuleWidth.NONE },
        { label: i18n['general.content.wideWidth'], value: EModuleWidth.WIDE },
      ],
    },
    {
      field: ResponsiveField.AutoPlay,
      disabled: responsiveType !== EPreviewSize.WIDE || !v,
    },
    {
      field: ResponsiveField.ContentPageToShow,
      disabled: !v,
      options: contentOptions,
    },
  ];

  const contentToShow = get(values, 'contentPagesToShow');
  if (contentToShow !== EResponsiveProductToShow.One) {
    const count = countsOfItems(contentToShow);
    commonFields = [
      ...commonFields,
      {
        field: ResponsiveField.LeaveGap,
        disabled: !v,
        options: uniqBy(
          contentOptions.map((v) => {
            return {
              label: replaceI18nVariables(
                countsOfItems_i18n(v?.value),
                i18n['general.label.content'],
              ),
              value: countsOfItems(v?.value),
            };
          }),
          (e) => e.value,
        ).slice(0, count),
      },
    ];
  }
  // commonFields = [
  //   ...commonFields,
  //   {
  //     field: ResponsiveField.CallToActionButton,
  //     disabled: responsiveType !== EPreviewSize.WIDE || !v,
  //   },
  // ];
  return commonFields;
};

import {
  animation_not_editable,
  getAnimationTemplate,
  getModuleStyleTemplate,
} from './imageCarousel';

export const getContentPageTemplate = (
  values: any,
  responsiveType: EPreviewSize,
) => {
  const v =
    responsiveType === EPreviewSize.WIDE || values[`${CONTENTS}_${editable}`];
  return [
    {
      field: ResponsiveField.Contents,
      hasModal: true,
      modalFunc: getModalTemplate,
      disabled: !v,
    },
  ];
};

export const getModalTemplate = () => {
  return {
    left: [{ field: ModalField.Content }],
    middle: [],
    right: [],
  };
};

export const cotentToShowOptions = (breakpoint: EPreviewSize) => {
  switch (breakpoint) {
    case EPreviewSize.WIDE: {
      return [
        {
          label: replaceI18nVariables(
            i18n['general.producttoshow.one'],
            i18n['general.label.content'],
          ),
          value: EResponsiveProductToShow.One,
        },
        {
          label: replaceI18nVariables(
            i18n['general.producttoshow.twoportrait'],
            i18n['general.label.content'],
          ),
          value: EResponsiveProductToShow.TwoPortrait,
        },
        {
          label: replaceI18nVariables(
            i18n['general.producttoshow.twolandscape'],
            i18n['general.label.content'],
          ),
          value: EResponsiveProductToShow.TwoLandscape,
        },
        {
          label: replaceI18nVariables(
            i18n['general.producttoshow.three'],
            i18n['general.label.content'],
          ),
          value: EResponsiveProductToShow.Three,
        },
        {
          label: replaceI18nVariables(
            i18n['general.producttoshow.four'],
            i18n['general.label.content'],
          ),
          value: EResponsiveProductToShow.Four,
        },
        {
          label: replaceI18nVariables(
            i18n['general.producttoshow.five'],
            i18n['general.label.content'],
          ),
          value: EResponsiveProductToShow.Five,
        },
        {
          label: replaceI18nVariables(
            i18n['general.producttoshow.six'],
            i18n['general.label.content'],
          ),
          value: EResponsiveProductToShow.Six,
        },
      ];
    }
    default: {
      return [
        {
          label: replaceI18nVariables(
            i18n['general.producttoshow.one'],
            i18n['general.label.content'],
          ),
          value: EResponsiveProductToShow.One,
        },
        {
          label: replaceI18nVariables(
            i18n['general.producttoshow.twoportrait'],
            i18n['general.label.content'],
          ),
          value: EResponsiveProductToShow.TwoPortrait,
        },
        {
          label: replaceI18nVariables(
            i18n['general.producttoshow.twolandscape'],
            i18n['general.label.content'],
          ),
          value: EResponsiveProductToShow.TwoLandscape,
        },
        {
          label: replaceI18nVariables(
            i18n['general.producttoshow.three'],
            i18n['general.label.content'],
          ),
          value: EResponsiveProductToShow.Three,
        },
      ];
    }
  }
};
